import { RcClasses } from '../../../../foundation';
export var RcListItemSecondaryActionClasses = RcClasses([], 'RcListItemSecondaryAction');
